jQuery(document).ready(function() {
    console.log("ada alt");

  jQuery('.product-block-list__item--description img[src*="FORBES-VETTED_BEST-OF"]').attr(
        'alt',
        'Forbes Vetted Best Of 2026'
    );
    jQuery('img[src="https://cdn.shopify.com/s/files/1/0530/4968/8259/files/Alpha_JX_backlite_graphic_ad.jpg?v=1782505171"]').attr(
    'alt',
    'Alpha Bidet JX2 remote control with backlit buttons, user presets, and adjustable wash and seat temperature settings'
);
jQuery('img[src="https://cdn.shopify.com/s/files/1/0530/4968/8259/t/7/assets/description_image_JX_LED1_min_min.jpg?v=1612726425"]').attr(
    'alt',
    'Modern bidet toilet installed in a bathroom with an illuminated LED night light'
);
jQuery('img[src="https://cdn.shopify.com/s/files/1/0530/4968/8259/files/378A6598.jpg?v=1723156750"]').attr(
    'alt',
    'Ultra-slim bidet toilet with a sittable lid and illuminated night light'
);
jQuery('img[src="https://cdn.shopify.com/s/files/1/0530/4968/8259/files/378A3006-party-mode_-v2.jpg?v=1723156749"]').attr(
    'alt',
    'Bidet toilet with a multicolor LED night light and party mode'
);
jQuery('img[src="https://cdn.shopify.com/s/files/1/0530/4968/8259/files/BidetKing-Crown-Updated-Remote-Design-378A2673-2.jpg?v=1757458787"]').attr(
    'alt',
    'BidetKing remote control with updated backlit symbols and illuminated buttons'
);

jQuery('img[src="https://cdn.shopify.com/s/files/1/0530/4968/8259/files/378A6577-Enhanced-NR.jpg?v=1723156749"]').attr(
    'alt',
    'Bidet toilet with illuminated seat highlighting cleansing features and a comfortable seat'
);

jQuery('img[src*="378A6502.jpg"]').attr(
    'alt',
    'Modern bidet toilet seat installed in a bathroom alongside a decorative vase with greenery and text reading EASY INSTALL + USER FRIENDLY'
);
jQuery('img[src*="crown_certifications.png"]').attr(
    'alt',
    'Certification logos for cUPC, TÜV SÜD safety tested, and FCC'
);
jQuery('img[src*="bidetking_crown_dimensions.png"]').attr(
    'alt',
    'Dimension diagram for BidetKing Crown showing measurements for Elongated and Round bidet seat models along with remote control dimensions'
);

jQuery('img[src*="alpha_ux_pearl_features.jpg"]').attr(
    'alt',
    'Feature grid for Alpha UX Pearl bidet seat showing wash spray nozzle, air dryer, LED night light, and wireless remote control'
);
jQuery('img[src*="ux_pearl_remote_480x480.jpg"]').attr(
    'alt',
    'Alpha UX Pearl wireless bidet remote control showing wash functions, temperature settings, and user preset buttons'
);

jQuery('img[src*="bndz6u85sspiye0l1kaf.png"]').attr(
    'alt',
    'Comparison graphic highlighting new sleek design features of the TOTO Washlet C5 versus the older C200 model'
);

jQuery('img[src*="tqsfa0lm0fpeniwdixo5.png"]').attr(
    'alt',
    'TOTO Washlet self-cleaning wand with EWATER+ technology'
);
jQuery('img[src*="DIRECTDRY2"]').attr(
    'alt',
    'Next Gen Drying DirectDry system with high speed fan motor'
);
jQuery('img[src*="uxt_flushing.jpg"]').attr(
    'alt',
    'Reliably strong flushing pressure assisted 1.28 GPF 1000 MaP smart toilet'
);

jQuery('img[src*="head.jpg"]').attr(
    'alt',
    'Sleek modern white integrated smart bidet toilet shown closed in a bathroom next to a potted plant'
);
jQuery('img[src*="AESTHETIC.jpg"]').attr(
    'alt',
    'Crisp and clean aesthetic white smart toilet with illuminated bowl and text highlighting flowing lines and balanced curves'
);
jQuery('img[src*="LEDS.jpg"]').attr(
    'alt',
    'Illuminating accents soft white rear and in-bowl LED lighting feature on a smart toilet'
);
jQuery('img[src*="CLEANSING.jpg"]').attr(
    'alt',
    'Innovative cleansing feature with bidet tech and advanced on-demand heating on a smart toilet'
);
jQuery('img[src*="AUTOMATED.jpg"]').attr(
    'alt',
    'Automated hygiene features including auto open close lid, auto dual flush, auto bowl pre-rinse, and auto foam shield'
);
jQuery('img[src*="FLUSHING.jpg"]').attr(
    'alt',
    'Reliably strong flushing pressure assisted 1 or 1.28 GPF dual flush 1000 MaP smart toilet'
);
jQuery('img[src*="UV-C.jpg"]').attr(
    'alt',
    'Beyond Clean dynamic UV-C water treatment system operating during cleansing cycles'
);

jQuery('img[src*="FOAM.jpg"]').attr(
    'alt',
    'Comfort redefined exclusive Foam Shield seals odors and prevents splashback inside toilet bowl'
);
jQuery('img[src*="AUTOMATED2.jpg"]').attr(
    'alt',
    'Automated hygiene features including auto open close lid, auto dual flush, and auto bowl pre-rinse'
);

jQuery('img[src*="function_comparison"]').attr(
    'alt',
    'Feature comparison table between BidetKing Throne Lite and BidetKing Throne showing UV-C sterilization, Foam Shield, Deodorizer, and 3-year warranty'
);
jQuery('img[src*="description_image_alphaone_sidesm"]').attr(
    'alt',
    'Side view profile of the Alpha ONE bidet seat featuring the chrome control lever for Wash and Bidet modes'
);
jQuery('img[src*="description_image_Alphaone3d"]').attr(
    'alt',
    '3D breakdown diagram of the Alpha One bidet seat highlighting its internal brass control valve, dual nozzles, and brass plumbing connections'
);
jQuery('img[src*="description_image_alphaone_spec"]').attr(
    'alt',
    'Specifications table for the Alpha ONE bidet seat detailing water flow, pressure range, dimensions, and weight'
);
jQuery('img[src*="Bb_Essentials_Lifestyle"]').attr(
    'alt',
    'Modern white toilet with open lid equipped with a side-mounted bidet attachment in a bright tiled bathroom setting'
);
jQuery('img[src*="description_image_CleanSpa_20hose_20detail.jpg"]').attr('alt', 'CleanSpa hose connector');

jQuery('img[src*="description_image_concealed_20trapways.jpg"]').attr('alt', 'Concealed and skirted toilet trapways');

jQuery('img[src*="2026_YAHOO_BEST-TESTED_LOGO_160x160.png"]').attr('alt', 'Yahoo Best Tested 2026 badge');

jQuery('img[src*="description_image_S_1400_Specifications.jpg"]').attr('alt', 'S1400 bidet seat specifications');

jQuery('img[src*="description_image_S_1400_fitment.jpg"]').attr('alt', 'S1400 elongated and round toilet fitment dimensions');

jQuery('img[src*="ix-pure-blue_600x600.jpg"]').attr('alt', 'CleanSpa Pure Blue bidet toilet');

jQuery('img[src*="ScreenShot2022-11-04at2.56.09PM.png"]').attr('alt', 'Bathroom toilet with storage shelves');

jQuery('img[src*="T44Profile_480x480.png"]').attr('alt', 'T44 bidet seat 99mm slim profile');

jQuery('img[src*="t442_480x480.png"]').attr('alt', 'T44 bidet seat front and back wash');

jQuery('img[src*="T44nightlight"]').attr('alt', 'Bio Bidet toilet seat with multicolored LED nightlight (blue, red, green)');

jQuery('img[src*="K300_SW3036_colors"]').attr('alt', 'Bidet toilet seat with remote control shown in Cotton White and Sedonda Beige color options');

jQuery('img[src*="K300_SW3036_dimensions"]').attr('alt', 'Technical dimension diagram of bidet toilet seat showing side, front, and top views with measurements');

jQuery('img[src*="T22Height"]').attr('alt', 'Side profile of slim bidet toilet seat measuring 99 millimeters high');

jQuery('img[src*="T22SidePanel2"]').attr('alt', 'Bidet toilet seat with easy-access side-button controls and aerated wash feature');

jQuery('img[src*="11-min"]').attr('alt', 'Bidet toilet seat installed in a modern luxury bathroom with marble tub and dark tiled walls');

jQuery('img[src*="T22NightLight"]').attr('alt', 'Bidet toilet seat remote glowing with blue LED nightlight in a dark bathroom');

jQuery('img[src*="T22Nozzle"]').attr('alt', 'Close-up of stainless steel self-cleaning retractable nozzle spraying water inside bidet toilet seat');

jQuery('img[src*="unexpectedluxury_ls-min"]').attr('alt', 'Bidet toilet seat installed on toilet in bright modern bathroom');

jQuery('img[src*="6-min"]').attr('alt', 'Bidet toilet seat surrounded by white and yellow floral arrangement against dark blue background');

jQuery('img[src*="61drqWyR7sL._AC_SX679__1_480x480.jpg"]').attr('alt', 'Twist control knob for adjusting water pressure on a shower head');

jQuery('img[src*="61Y7s4e0-tL._AC_SX679__1_480x480.jpg"]').attr('alt', 'Bidet attachment with dual nozzle spray options and twist control knob for water pressure adjustment');

jQuery('img[src*="description_image_BB_70_20Specifications"]').attr('alt', 'Product specification diagram with measurements: top width 7.28 inches, height 23.2 inches, bottom width 7.79 inches, and other dimensional callouts for BB-70 model assembly');

jQuery('img[src*="description_image_TOTO_RH_Specs_min"]').attr('alt', 'TOTO RH series product specification diagram with 16 dimensional callouts in inches and millimeters, including width 15-3/16 in (386 mm), height 40-1/8 in (1019 mm), depth 21-1/16 in (535 mm), and other installation measurements for plumbing fixture dimensions');

jQuery('img[src*="description_image_jxdimensions"]').attr('alt', 'JX series product dimension diagram with key measurements: X=5.5in, width 19.4in, height 20.8in, round and elongated bowl options');

$('img[src*="files/alphajxblue-9758.jpg?v=1691512362"]').attr('alt', 'Alpha JX Bidet Toilet Seat - top view');

jQuery('img[src*="description_image_toiletmeasurements"]').attr('alt', 'Diagram comparing elongated and round toilet shapes, showing measurement requirements: A ≥ 1.5 inches for both, B = 5–7.5 inches for both, and C > 18 inches for elongated versus C < 18 inches for round.');

jQuery('img[src*="description_image_bidet_seat_combo"]').attr('alt', 'Add a Bidket to my existing toilet');
jQuery('img[src*="description_image_bidet_toilet_combo"]').attr('alt', 'Replace my toilet with an integrated bidet toilet combo.');







});